<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-value="id"
    item-text="address"
    :items="busStops"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    clearable
    :loading="loading"
  >
  </v-autocomplete>
</template>

<script>
// import { mapGetters } from 'vuex'
import { BusStop } from '@/plugins/api'

export default {
  data: () => ({
    loading: false,
    busStops: []
  }),
  props: {
    filters: Object
  },
  computed: {},
  created() {
    this.filters && this.fetchAllBusStops(this.filters)
  },
  watch: {
    filters: {
      handler(filters) {
        this.fetchAllBusStops(filters)
      },
      deep: true
    }
  },
  methods: {
    async fetchAllBusStops(query) {
      query = query || {}
      this.loading = true
      const params = {
        ...query,
        _limit: -1
      }
      this.busStops = await BusStop.fetch(params)
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    }
  }
}
</script>
